// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconCollapse.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconCollapse = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 12 12" fill="currentColor" { ...props }>
    <path fillRule="evenodd" clipRule="evenodd" d="M0 3.43315C0 1.53708 1.53708 0 3.43316 0H8.56684C10.4629 0 12 1.53708 12 3.43316V8.56684C12 10.4629 10.4629 12 8.56684 12H3.43315C1.53708 12 0 10.4629 0 8.56684V3.43315ZM3.43316 0.705882C1.92692 0.705882 0.705882 1.92692 0.705882 3.43315V8.56684C0.705882 10.0731 1.92692 11.2941 3.43315 11.2941H8.56684C10.0731 11.2941 11.2941 10.0731 11.2941 8.56684V3.43316C11.2941 1.92692 10.0731 0.705882 8.56684 0.705882H3.43316ZM8.56684 6.35294H3.43316V5.64706H8.56684V6.35294Z" />
  </BaseIcon>
);

export default IconCollapse;
